import React from 'react';

function CloseOval({ stroke = '#5e2064', width = 16, height = 16, ...rest }) {
  return (
    <svg
      fill="#000000"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      id="cross-circle"
      data-name="Flat Color"
      xmlns="http://www.w3.org/2000/svg"
      className="icon flat-color"
      {...rest}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <circle id="primary" cx="12" cy="12" r="10" style={{ fill: stroke }} />
        <path
          id="secondary"
          d={
            'M13.41,12l2.3-2.29a1,1,0,0,0-1.42-1.42L12,10.59,9.71,8.29A1,1,0,0,0,8.29,9.71L10.59,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z'
          }
          style={{ fill: '#ffffff' }}
        />
      </g>
    </svg>
  );
}

export default CloseOval;
